import  { useState } from 'react';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const AddLessonModal = ({ openLessonModal, setOpenLessonModal, moduleId, fetchCourseContent }) => {
  const [title, setTitle] = useState('');
  const [type, setType] = useState('video');
  const [contentFile, setContentFile] = useState(null);
  const [resources, setResources] = useState([]);
  const [isPreview, setIsPreview] = useState(false);
  const [fileKey, setFileKey] = useState(0); 
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async () => {
    if (!title || !contentFile || !moduleId) return;
    setIsLoading(true); // Start loading
    const formData = new FormData();
    formData.append("module", moduleId.toString());
    formData.append("title", title);
    formData.append("type", type);
    formData.append("content_file", contentFile);
    formData.append('isPreview', isPreview ? '1' : '0');  
    resources.forEach((file) => {
      formData.append("resources", file);
    });
    try {
      const res = await fetch(`${BASE_URL}/courses/course/module/lesson/create`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        alert("Lesson Added Successfully");
        fetchCourseContent();
        setTitle("");
        setType("video");
        setContentFile(null);
        setResources([]);
        setIsPreview(false);
        setOpenLessonModal(false);
      } else {
        console.error("Error creating lesson:", data);
        alert("Failed to add lesson");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong");
    } finally {
      setIsLoading(false); 
    }
  };
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) setOpenLessonModal(false);
  };
  if (!openLessonModal) return null;
  const getAcceptType = (type) => {
    switch (type) {
      case "video":
        return "video/*";
      case "audio":
        return "audio/*";
      case "pdf":
        return "application/pdf";
      case "doc":
        return ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case "ppt":
        return ".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation";
      case "txt":
        return "text/plain";
      case "code":
        return ".js,.jsx,.ts,.tsx,.py,.java,.cpp,.c,.cs,.php,.rb,.go,.rs,.swift,.kt,.kts,.html,.css,.scss,.json,.xml,.yaml,.yml,.sql,.sh,.bash,.md";
      default:
        return "";
    }
  };

  return (
  <div
  className={`fixed inset-0 bg-black/50 mt-20 flex justify-center items-center z-50 transition-opacity ${
    openLessonModal ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
  }`}
  onClick={handleOverlayClick}
>
  <div
    className="bg-white rounded-2xl max-h-[90vh] overflow-y-auto w-[90%] max-w-3xl shadow-xl border border-gray-200"
    onClick={(e) => e.stopPropagation()}
  >
    {/* Header */}
    <div className="p-6 border-b border-gray-100">
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              {isLoading ? 'Uploading Lesson...' : 'Add New Lesson'}
            </h2>
            <p className="text-sm text-gray-500 mt-0.5">
              {isLoading
                ? 'Please wait while we upload your lesson...'
                : 'Add a new lesson to your course'}
            </p>
          </div>
        </div>
        {!isLoading && (
          <button
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setOpenLessonModal(false)}
          >
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>

    {/* Content */}
    <div className="p-6">
      {isLoading ? (
        <div className="flex flex-col items-center justify-center py-8">
          <div className="w-12 h-12 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin mb-4"></div>
          <p className="text-sm text-gray-700 font-medium">Uploading your lesson content...</p>
          <p className="text-xs text-gray-500 mt-2">
            This may take a few moments depending on file size
          </p>
        </div>
      ) : (
        <>
          {/* Lesson Title */}
          <div className="mb-5">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">Lesson Title</label>
            </div>
            <input
              type="text"
              placeholder="Enter lesson title..."
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              autoFocus
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            />
          </div>

          {/* Type */}
          <div className="mb-5">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">Type</label>
            </div>
            <select
              value={type}
              onChange={(e) => {
                setType(e.target.value);
                setFileKey((prev) => prev + 1);
              }}
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 16px center'
              }}
            >
              <option value="video">Video</option>
              <option value="audio">Audio</option>
              <option value="pdf">PDF</option>
              <option value="doc">DOC / DOCX</option>
              <option value="ppt">PPT / PPTX</option>
              <option value="txt">TXT</option>
              <option value="code">Code (JS, PY, HTML, etc.)</option>
            </select>
          </div>

          {/* Content File */}
          <div className="mb-5">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">Upload Content File</label>
            </div>
            <div className="relative">
              <input
                key={fileKey}
                type="file"
                accept={getAcceptType(type)}
                onChange={(e) => setContentFile(e.target.files[0])}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
              />
              <div className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-500 text-sm flex items-center gap-2">
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                </svg>
                <span className="truncate">{contentFile ? contentFile.name : 'Choose file...'}</span>
              </div>
            </div>
          </div>

          {/* Extra Resources */}
          <div className="mb-5">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">Extra Resources</label>
            </div>
            <div className="relative">
              <input
                type="file"
                multiple
                onChange={(e) => setResources([...e.target.files])}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
              />
              <div className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-500 text-sm flex items-center gap-2">
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                <span className="truncate">
                  {resources?.length ? `${resources.length} file(s) selected` : 'Choose files...'}
                </span>
              </div>
            </div>
          </div>

          {/* Is Preview */}
          <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
            <div className="relative">
              <input
                type="checkbox"
                id="isPreview"
                checked={isPreview}
                disabled={!(type === 'video' || type === 'audio')}
                onChange={(e) => setIsPreview(e.target.checked)}
                className="sr-only"
              />
              <div className={`w-5 h-5 border-2 rounded flex items-center justify-center transition-colors ${
                isPreview 
                  ? 'bg-[#0f6abf] border-[#0f6abf]' 
                  : 'border-gray-300 bg-white'
              }`}>
                {isPreview && (
                  <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
            </div>
            <label htmlFor="isPreview" className="text-sm font-medium text-gray-700 cursor-pointer">
              Is Preview?
            </label>
            <span className="text-xs text-gray-500 ml-auto">
              {!(type === 'video' || type === 'audio') && '(Only available for video/audio)'}
            </span>
          </div>
        </>
      )}
    </div>

    {/* Actions */}
    {!isLoading && (
      <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={() => setOpenLessonModal(false)}
            className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={!title || !contentFile || isLoading}
            className="px-5 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Lesson
          </button>
        </div>
      </div>
    )}
  </div>
</div>
  );
};

export default AddLessonModal;